import { ExportColumn } from '../../../interfaces/ExportColumn';

export const baseColumnsLocationSummary: ExportColumn[] = [
  {
    key: 'locationName',
    header: 'Location',
    type: 'text',
    width: 45,
  },
  {
    key: 'directRevenueSupported',
    header: 'Direct Revenue Supported',
    type: 'money',
    nestedKey: 'directRevenueSupported',
    width: 45,
  },
  {
    key: 'indirectRevenueSupported',
    header: 'Indirect Revenue Supported',
    type: 'money',
    nestedKey: 'indirectRevenueSupported',
    width: 45,
  },
  {
    key: 'totalRevenueSupported',
    header: 'Total Revenue Supported',
    type: 'money',
    nestedKey: 'totalRevenueSupported',
    width: 45,
  },
  {
    key: 'rebuildTime',
    header: 'Rebuild Time (months)',
    type: 'number',
    nestedKey: 'rebuildTime',
    width: 30,
  },
  {
    key: 'finishedGoodsInventory',
    header: 'Finished Goods Inventory',
    type: 'money',
    nestedKey: 'finishedGoodsInventory',
    width: 45,
  },
  {
    key: 'mitigation',
    header: 'Mitigation',
    type: 'money',
    nestedKey: 'mitigation',
    width: 45,
  },
  {
    key: 'mitigationPercentage',
    header: 'Mitigation %',
    type: 'percentage',
    nestedKey: 'mitigationPercentage',
    width: 30,
  },
  {
    key: 'netRevenueExposure',
    header: 'Residual Revenue Exposure',
    type: 'money',
    nestedKey: 'netRevenueExposure',
    width: 45,
  },
];

export const baseColumnsProcessAreasSummary: ExportColumn[] = [
  { key: 'name', header: 'Process Area', type: 'text', width: 45 },
  { key: 'locationName', header: 'Location', type: 'text', width: 30 },
  {
    key: 'annualRevenueSupported',
    header: 'Annual Revenue Supported',
    type: 'money',
    width: 45,
  },
  {
    key: 'rebuildTime',
    header: 'Rebuild Time (months)',
    type: 'number',
    width: 30,
  },
  {
    key: 'totalRevenueExposure',
    header: 'Total Revenue Exposure',
    type: 'money',
    width: 45,
  },
  { key: 'totalMitigation', header: '$ Mitigation', type: 'money', width: 45 },
  {
    key: 'totalMitigationPercentage',
    header: 'Mitigation %',
    type: 'percentage',
    width: 30,
  },
  { key: 'bcpStatus', header: 'BCP Status', type: 'text', width: 35 },
  {
    key: 'residualRevenueExposure',
    header: 'Residual Revenue Exposure',
    type: 'money',
    width: 45,
  },
];

export const baseColumnsProcessesSummary: ExportColumn[] = [
  { key: 'name', header: 'Process', type: 'text', width: 45 },
  { key: 'locationName', header: 'Location', type: 'text', width: 30 },
  {
    key: 'annualRevenueSupported',
    header: 'Annual Revenue Supported',
    type: 'money',
    width: 45,
  },
  {
    key: 'rebuildTime',
    header: 'Rebuild Time (months)',
    type: 'number',
    width: 30,
  },
  {
    key: 'totalRevenueExposure',
    header: 'Total Revenue Exposure',
    type: 'money',
    width: 45,
  },
  { key: 'totalMitigation', header: '$ Mitigation', type: 'money', width: 45 },
  {
    key: 'totalMitigationPercentage',
    header: 'Mitigation %',
    type: 'percentage',
    width: 30,
  },
  { key: 'bcpStatus', header: 'BCP Status', type: 'text', width: 35 },
  {
    key: 'residualRevenueExposure',
    header: 'Residual Revenue Exposure',
    type: 'money',
    width: 45,
  },
];
